export const getOperator = state => state.operator.data.operator.length ? state.operator.data.operator : [{ value: '-1', label: 'Cargando...'}];
export const getSessionRol = state => state.operator.errorRol;
export const getMessage = state => state.operator.errorMessage;
